<template>
	<v-row>
		<v-col
			cols="12"
			sm="6"
			md="4"
			xl="3"
			v-for="offer in investmentOffers"
			:key="offer.id"
		>
			<offer-card :offer="offer" :isOnboarding="isOnboarding" />
		</v-col>

		<v-col cols="12">
			<v-row
				class="fill-height"
				v-if="!isLoading && investmentOffers.length == 0"
			>
				<v-col cols="12">
					<div
						class="d-flex flex-column fill-height align-center justify-center py-16"
					>
						<div class="text-h5 font-weight-medium text-center">
							No available offers
						</div>
						<v-btn
							depressed
							small
							tile
							color="secondary"
							class="text-none py-6 px-8 mt-8"
							@click="fetchInvestmentOffers"
							>Refresh</v-btn
						>
					</div>
				</v-col>
			</v-row>
			<v-row v-if="isLoading">
				<v-col cols="12" sm="6" md="4" xl="3" v-for="i in 8" :key="i">
					<v-skeleton-loader
						:max-width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
						:width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
						v-bind="attrs"
						height="350"
						type="image, article, actions"
					></v-skeleton-loader>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
	import OfferCard from "@/components/investments/OfferCard.vue";
	import { TransactionService } from "@/services/index.js";

	export default {
		components: {
			OfferCard,
		},
		props: {
			isOnboarding: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				isLoading: false,
				investmentOffers: [],
				allInvestments: [],
				attrs: {
					class: "mb-6",
					boilerplate: true,
					elevation: 0,
				},
			};
		},
		methods: {
			async fetchInvestmentOffers() {
				try {
					this.isLoading = true;
					const res = await TransactionService.getActivePackages();

					let result = res?.data;
					result = [...result].filter((item) => item.visible);

					this.investmentOffers = result;
				} catch (error) {
					this.isLoading = false;
				} finally {
					this.isLoading = false;
				}
			},
			groupInvestments(investments) {
				let result = investments.reduce((acc, item) => {
					const isItemInArray = acc.find(
						(investment) =>
							investment.id == item.id || item.roi == investment.roi
					);

					if (isItemInArray) return acc;
					return [...acc, item];
				}, []);
				return result;
			},
		},
		mounted() {
			this.fetchInvestmentOffers();
		},
	};
</script>
